import { requestRoot } from '@/axios';

export const saveStudentActivity = async (childId, time) => requestRoot.post('/accounts/child/time/update', {
  childId,
  last_played: new Date().toISOString(),
  time,
});
